module.exports = __webpack_public_path__ + "static/media/logobanner.260255f2.jpg";